import { IAssignmentPlan } from '@api'

export function redirectTo(plan: IAssignmentPlan) {
  const pathname = window.location.pathname.replace(
    /\/floor_plan\/(\w+)\/ap\/(\w+)/gi,
    (_, floorId) => `/floor_plan/${floorId}/ap/${plan.id}`
  )
  window.location.pathname = pathname
}
